<template>
  <div id="detaildata">
    <mt-header :title="this.$store.getters.WordsConfig.CellList.wjgl">
      <a slot="left" @click="closePopup">
        <mt-button icon="back"></mt-button>
      </a>
    </mt-header>
    <div style="position: absolute;top: 40px;left: 0;right: 0;bottom: 26px;">
      <el-table :data="tableData"
                height="100%"
                :empty-text="this.$store.getters.WordsConfig.TBEmptyText">
        <el-table-column fixed
                         prop="gameId"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.gameId"
                         header-align="center"
                         align="center"
                         width="88"></el-table-column>
        <el-table-column prop="gameAccount"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.gameAccount"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="Profit"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.Profit"
                         width="120"
                         header-align="center"
                         align="center"  v-if="this.$store.getters.UserInfo.displayType === 0"></el-table-column>
        <el-table-column prop="RechargeScore"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.RechargeScore"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="WithdrawScore"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.WithdrawScore"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>


        <el-table-column prop="gameBindTime"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.gameBindTime"
                         width="180"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="lastLogin"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.lastLogin"
                         width="180"
                         header-align="center"
                         align="center"></el-table-column>
      </el-table>
      <el-pagination small
                     class="pagination"
                     background
                     :total="total * 1"
                     :page-size="25"
                     layout="prev, pager, next"
                     :current-page.sync="currentPage"
                     @current-change="getNextPage"></el-pagination>
    </div>
  </div>
</template>

<script>
  import { G_SubU } from "../../api/api.js";
  export default {
    data() {
      return {
        currentPage: 1,
        type: 0,
        tableData: [],
        curPage: 0
      };
    },
    props: ["total", "st", "et", "datetype"],
    mounted() { },
    methods: {
      firData(type) {
        this.type = type;
        this.tableData = [];
        this.getData(0, this.st, this.et);
      },
      closePopup() {
        this.curPage = 0;
        this.$emit("closePopup");
      },
      getNextPage(currPage) {
        this.tableData = [];
        this.getData(currPage - 1, this.st, this.et);
      },
      getData(id, st = 0, et = 0, nickname = "", gameid = 0, datetype=10000) {
        G_SubU(id, 25, datetype, st, et, nickname, gameid, this.type)
          .then(res => {
            console.log("G_SubU");
            console.log(res);
            console.log(res.data[0].totalCount);
            this.totalcount = res.data[0].totalCount;
            for (const it of res.data) {
              let item = {
                gid: it.id,
                gameId: it.gameID,
                gameAccount: it.accounts,
                RechargeScore: it.rechargeScore,
                WithdrawScore: it.withdrawScore,
                Profit: it.totalProfit,
                gameBindTime: it.bindDate,
                lastLogin: it.lastLogonDate
              };
              console.log(item);
              this.tableData.push(item);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .pagination {
    position: absolute;
    bottom: -26px;
    width: 100%;
    background: white;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cells/DetailData.vue